module.exports = __webpack_public_path__ + "img/headerBluebookmark.f01bffdd.svg";